import Nav from '@/components/Nav';
import { Box } from '@mui/material';
import Footer from '@/components/Footer';
import { makeStyles } from '@mui/styles';
import useURLsContext from '@/context/URLsContext';

const useStyles = makeStyles(() => {
  return {
    footerBottom: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
    },
  };
});

const Default = ({ children }) => {
  const classes = useStyles();
  const urls = useURLsContext();
  return (
    <Box sx={{ position: 'relative', minHeight: '100vh' }}>
      <Nav />
      <Box
        sx={(theme) => {
          return {
            [theme.breakpoints.down('lg')]: {
              paddingBottom: '75px',
            },
            paddingBottom: '59px',
          };
        }}>
        {children}
      </Box>
      <Footer className={classes.footerBottom} termsUrl={urls?.TOSUrl || undefined} />
    </Box>
  );
};
export default Default;
